import type { InternalProtocolSidecarStatusResponse } from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE_PATH = '/v1/ops/protocol-sidecar';

export async function getProtocolSidecarStatus(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<InternalProtocolSidecarStatusResponse> {
  return opsApiRequest<InternalProtocolSidecarStatusResponse>(
    BASE_PATH,
    { signal },
    fetchImpl,
  );
}
